import React from 'react';
import { COUPON_DISCOUNT_TYPE_TEXT, COUPON_DISCOUNT_TYPE } from '../../../../constants/service/app/couponConstants';
import { setNumberWithComma } from '../../../../lib/common';

const CouponBenefit = (props) => {
  const { type, amount } = props;
  let amountUnit = null;

  if (type === COUPON_DISCOUNT_TYPE.PRICE) amountUnit = '원';
  else if (type === COUPON_DISCOUNT_TYPE.RATE) amountUnit = '%';

  return (
    <div>
      <div>{COUPON_DISCOUNT_TYPE_TEXT[type]}</div>
      <div>{setNumberWithComma(amount, amountUnit)}</div>
    </div>
  );
};

export default CouponBenefit;
